import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { QueryKey } from '@/Config/api/queryKey';
import { AssistedRevenueSummaryDto } from '@/Domain/api/AssistedOrders/AssistedOrders.dto';
import { DateRangeState } from '@/Domain/types/DateRange.types';

const toISODate = (date: Date) => format(date, 'yyyy-MM-dd');

export const useAssistedRevenueSummary = (range: DateRangeState) =>
  useQuery<AssistedRevenueSummaryDto>({
    queryKey: [
      QueryKey.assistedOrders.summary,
      { start_date: toISODate(range.startDate), end_date: toISODate(range.endDate) },
    ],
  });
